module.exports = __webpack_public_path__ + "img/home_load_item.adb88db5.svg";